import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { TabBarMixedWebElement } from './TabBarMixedWebElement';
export { TabBarMixedWebElement };

/**
 * Retrieve an instance of [TabBarMixedWebElement](../classes/TabBarMixedWebElement.html).
 * @example
 * ```javascript
 * import { findTabBarMixed } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findTabBarMixed(driver, By.id('my-oj-c-tab-bar-mixed'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findTabBarMixed(driver: DriverLike, by: By): Promise<TabBarMixedWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type TabBarMixedWebElement
  if (!(webEl instanceof TabBarMixedWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'TabBarMixedWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findTabBarMixed(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${TabBarMixedWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-tab-bar-mixed', TabBarMixedWebElement);
